import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { StakeholderResponse, Stakeholder } from '../interfaces/stakeholder.interface';
import { environment } from '../../app/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StakeholderService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getStakeholders(): Observable<Stakeholder[]> {
    return this.http.get<StakeholderResponse>(`${this.apiUrl}/stake-holders`).pipe(
        map(response => response.data)
      );
    }
}
